import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 1c1.657 0 3 1.343 3 3v2h1c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h1V4c0-1.657 1.343-3 3-3zm0 7.5c-.552 0-1 .448-1 1 0 .37.201.693.5.866V11.5c0 .276.224.5.5.5s.5-.224.5-.5l.001-1.134C8.8 10.193 9 9.87 9 9.5c0-.552-.448-1-1-1zM8 2c-1.054 0-1.918.816-1.995 1.85L6 4v2h4V4c0-1.105-.895-2-2-2z",
    transform: "translate(-57 -223) translate(37 171) translate(0 40) translate(20 12)"
  })))))));
});